import types from '../types';

const initialState = {
  jwtAccessToken: '',
    filterModal: false,
   districts: [],

  taluks: [],

  loading: false,

  error: null,

};


const filterReducer = (state = initialState, action) => {

  switch (action.type) {

    case types.FETCH_DISTRICTS_REQUEST:

    case types.FETCH_TALUKS_REQUEST:

      return {

        ...state,

        loading: true,

        error: null,

      };

    case types.FETCH_DISTRICTS_SUCCESS:

      return {

        ...state,

        loading: false,

        districts: action.payload,

      };

    case types.FETCH_TALUKS_SUCCESS:

      return {

        ...state,

        loading: false,

        taluks: action.payload,

      };

    case types.FETCH_DISTRICTS_FAILURE:
      return {

        ...state,

        loading: false,

        error: action.error,

        districts:[],

      };


    case types.FETCH_TALUKS_FAILURE:

      return {

        ...state,

        loading: false,

        error: action.error,
        taluks:[],

      };
      case types.CLEAR_DISTRICTS:
      return {

        ...state,
        districts:[],

      };
      
      case types.CLEAR_TALUKS:

      return {

        ...state,
        taluks:[],

      };
      

    default:

      return state;

  }

};

export default filterReducer;
 